import { AfterViewInit, Injectable } from '@angular/core';
declare var embedSurvey: any;
@Injectable({
  providedIn: 'root',
})
export class ServeyService {
    constructor() {

      }
    // ngAfterViewInit(): void {
    //     this.loadSurvey();
    //   }
      loadJsAsync(src: any, callback: any) {
        var s = document.createElement('script');
        s.type = "text/javascript";
        s.src = src;
        s.addEventListener('load', function (e) { callback(null, e); }, false);
        var head = document.getElementsByTagName('head')[0];
        head.appendChild(s);
      }
      loadSurvey() {
        const informationSurvey = JSON.parse(localStorage.getItem('informationForSurvey'))
        const dataFromAPI = JSON.parse(JSON.parse(localStorage.getItem('dataForSurvey')))
        // const ramdom= informationSurvey.name + Math.random();
    //    this.loadJsAsync('http://10.207.252.82:8282/BCCS_CC/assets/js/embedSurvey.js', function () {
         this.loadJsAsync(informationSurvey.surveyURL, function () {
           let dataFormat = [{
             isdn: informationSurvey.name,//isdn/mã số thuế/đối tượng survey
             surveyAtt:dataFromAPI.surveyAtt ,
             surveyAttValue:dataFromAPI.surveyAttValue,  //hệ thống survey
             CAMPAIGN_CONTACT_NUMBER: informationSurvey.CAMPAIGN_CONTACT_NUMBER ? informationSurvey.CAMPAIGN_CONTACT_NUMBER : null,
             PROVINCE_CODE:informationSurvey.PROVINCE_CODE ? informationSurvey.PROVINCE_CODE : null,
             DISTRICT_CODE:informationSurvey.DISTRICT_CODE ? informationSurvey.DISTRICT_CODE : null,
             PRECINCT_CODE:informationSurvey.PRECINCT_CODE ? informationSurvey.PRECINCT_CODE : null,
             SME_ADDRESS:informationSurvey.SME_ADDRESS ? informationSurvey.SME_ADDRESS : null,
           }
             ];
           for (let obj of dataFormat) {
             for (let key in obj) {
               if (obj[key] === null) {
                 delete obj[key];
               }
             }
           }
          var data = {
            serviceName:dataFromAPI.serviceName,
            // elementId: 'main-content', // Id element Append Frame nội dung khảo sát
            // inbox: true, // Bỏ qua Câu hỏi ban đầu
            frameId:dataFromAPI.frameId, // Id của Frame
            style: {
              width: Number(dataFromAPI.width),
              height: Number(dataFromAPI.height)
            },
            isdn: [informationSurvey.name],//isdn/mã số thuế/đối tượng survey
            surveyName: dataFromAPI.surveyName, //Tên survey
            forCampaign:Number(dataFromAPI.forCampaign), //khảo sát là chiến dịch (giá trị = 1), không phải chiến dịch (giá trị = 2)
            // bussinessId: 7323,
            surveyType:Number(dataFromAPI.surveyType), //mã chiến dịch ứng với từng hệ thống (với Sinvoice thì = 7)
            channelSurvey: dataFromAPI.channelSurvey,
            listSurveyAtt: dataFormat,
            isNumber:Number(dataFromAPI.isNumber), //chấm điểm thao số hoặc sao, (=1 chấm theo số, =0 chấm theo sao)
            identification:Number(dataFromAPI.identification)// survey định danh hay không định danh (=1 định danh, =0 không định danh)
          };
            embedSurvey(data);
        //   data.frameId='sur2';
        //   embedSurvey(data);
        })
      }
}
